<template>
    <div class="Footer-wrap">
        <div class="Footer">
            <div class="footer-top">
                <div class="left">
                    <div class="content">
                        <img src="../assets/foot_logo.png"/>
                        <p><span>苏州弘瀚自动化科技有限公司</span></p>
                        <p>电话: 0512-68321638</p>
                        <p>邮箱: sales@sz-falcon.com</p>
                        <p>地址: 苏州高新区湘江路1508号1号楼北区3楼</p>
                    </div>
                </div>

                <div class="right">
                    <ul class="out">
                        <li v-for="(item,index) in footerList" :key="index">
                            <p><router-link :to="item.path">{{item.name}}</router-link></p>
                            <ul class="inside">
                                <li v-for="(items, indexs) in item.children" :key="indexs">
                                    <router-link :to="{path: items.path, query: {tabid: indexs}}" tag="div">
                                        {{items.name}}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer-bottom">
                <a href="https://beian.miit.gov.cn" target="_blank">
                    <p>Copyright © 版权所有 苏州弘瀚自动化科技有限公司 苏ICP备19026559号</p>
                </a>
            </div>
        </div>

        <div class="footer-sj">
            <ul>
                <li v-for="(item,index) in footerList" :key="index">
                    <p><router-link :to="item.path">{{item.name}}</router-link></p>
                </li>
            </ul>

            <div class="contact">
                <div class="left">
                    <img src="../assets/foot_logo.png" />
                </div>
                <div class="right">
                    <p>电话： 0512-68321638</p>
                    <p>邮箱：sales@sz-falcon.com</p>
                    <div>
                        <p>地址：</p>
                        <p> 苏州高新区湘江路1508号1号楼北区3楼</p>
                    </div>
                    
                </div>
            </div>

            <div class="bottom">
                <a href="https://beian.miit.gov.cn" target="_blank">
                    <p>Copyright © 版权所有 苏州弘瀚自动化科技有限公司</p>
                    <p>苏ICP备19026559号</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  data(){
      return{
        footerList: [
            {
                id: '0',
                name: "首页",
                path: "/",
                children: [
                    {
                        id: "1-1",
                        name: "企业简介",
                        path: "/About",
                        active: true,
                    },
                    {
                        id: "1-2",
                        name: "产品中心",
                        path: "/Product",
                        active: true,
                    },
                    {
                        id: "1-3",
                        name: "专案展示",
                        path: "/IndustryCase",
                        active: true,
                    },
                    {
                        id: "1-4",
                        name: "行业动态",
                        path: "/News",
                        active: true,
                    },
                ], 
            },
            {
                id: '1',
                name: "关于弘瀚",
                path: "/About" ,
                children: [
                    {
                        id: "1-1",
                        name: "公司简介",
                        path: "/About",
                        active: true,
                    },
                    {
                        id: "1-2",
                        name: "公司荣誉",
                        path: "/About",
                        active: true,
                    },
                    // {
                    //     id: "1-3",
                    //     name: "企业文化",
                    //     path: "/About",
                    //     active: true,
                    // },
                    {
                        id: "1-3",
                        name: "发展历程",
                        path: "/About",
                        active: true,
                    },
                ],
            },
            {
                id: '2',
                name: "产品中心",
                path: "/Product" ,
            },
            {
                id: '3',
                name: "行业案例",
                path: "/IndustryCase" ,
            },
            {
                id: '4',
                name: "行业动态",
                path: "/News" ,
                children: [
                    {
                        id: "1-1",
                        name: "新闻中心",
                        path: "/News",
                        active: true,
                    }
                ],
            },
            {
                id: '5',
                name: "联系我们",
                path: "/ContactUs" ,
                children: [
                    {
                        id: "5-1",
                        name: "联系方式",
                        path: "/ContactUs",
                        active: true,
                    },
                    {
                        id: "5-1",
                        name: "在线地图",
                        path: "/ContactUs",
                        active: true,
                    }
                ],
            }
          ]
      }
  }
}
</script>

<style scoped>
    .Footer{
        margin-top: 200px;
        background-image: url(../assets/foot_img.png);
    }

    .footer-top{
        display: flex;
        justify-content: space-between;
        width: 66.66%;
        height: 420px;
        margin: 0 auto;
    }

    .footer-bottom{
        height: 40px;
        background-color: #323F4F;
    }

    .footer-bottom a{
        text-decoration:none;
    }

    .footer-bottom p{
        margin: 0;
        text-align: center;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        line-height: 40px;
        color: #999999;
    }

    .Footer .left{
        width: 30%;
        height: 280px;
        box-sizing: border-box;
        margin-top: 80px;
        padding-right: 30px;
    }

    .Footer .left .content img{
        width: 120px;
        height: 120px;
    }

    .Footer .left .content p{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        line-height: 24px;
        color: #FFFFFF;
    }

    .Footer .left .content p span{
        display: block;
        margin-bottom: 20px;
        text-align: left;
        font-size: 15px;
        font-family: MicrosoftYaHei;
        line-height: 24px;
        color: #FFC200;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .Footer .right{
        margin-top: 80px;
        padding-left: 7.5%;
        box-sizing: border-box;
        width: 70%;
        height: 280px;
        border-left: 1px dashed #ddd;
    }

    .Footer .right ul{
        list-style: none;
    }

    .Footer .right .out{
        display: flex;
        margin: 0;
    }

    .Footer .right .out > li{
        width: 145px;
    }

    .Footer .right .out > li > p{
        margin-bottom: 20px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 24px;
        color: #FFC200;
    }

    .Footer .right .out > li > p > a{
        text-decoration: none;
        color: #FFC200;
    }

    .Footer .right .out > li > .inside{
        padding: 0;
        text-align: left;
    }

    .Footer .right .out > li > .inside > li{
        margin-bottom: 10px;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        line-height: 24px;
        color: #FFFFFF;
    }

    .Footer .right .out > li > .inside > li a{
        text-decoration: none;
        color: #fff;
    }

    .Footer .right .out > li > .inside > li div:hover{
        cursor:pointer;
        color: #FFC200;
    }

    .footer-sj{
        display: none;
    }

    .footer-sj .bottom a{
        text-decoration:none;
    }

    @media (max-width: 1000px){ 
        .Footer{
            display: none;
        }

        .footer-sj{
            margin-top: 120px;
            background-color: #273444;
            display: block;
        }

        .footer-sj ul{
            list-style: none;
            box-sizing: border-box;
            padding: 25px 20px 12px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        .footer-sj ul li{
            width: 33.33%;
        }

        .footer-sj ul li p a{
            display: block;
            text-decoration: none;
            color: #fff;
            line-height: 36px;
            padding-left: 10px;
            font-size: 16px;
        }

        .footer-sj .contact{
            display: flex;
            box-sizing: border-box;
            padding: 0 20px 12px;
            border-bottom: 1px solid #666;
        }

        .footer-sj .contact .left{
            position: relative;
            padding-right: 15px;
        }
        
        .footer-sj .contact .left::after{
            position: absolute;
            top: 15px;
            right: 0;
            content: "";
            width: 1px;
            height: 65px;
            background-color: #fff;
        }

        .footer-sj .contact .left img{
            width: 90px;
        }

        .footer-sj .contact .right{
            width: 100%;
            padding-left: 20px;
        }

        .footer-sj .contact .right p{
            color: #fff;
            line-height: 28px;
            font-size: 14px;
        }

        .footer-sj .contact .right div p:nth-child(1){
            width: 42px;
            height: 60px;
            float: left;
        }

        .footer-sj .bottom{
            padding: 10px 0 15px;
        }

        .footer-sj .bottom p{
            font-family: PingFang SC-Medium, PingFang SC;
            font-size: 12px;
            color: #999;
            line-height: 20px;
            text-align: center;
        }
    }

    @media (max-width: 400px){ 
        .footer-sj .contact{
            padding: 0 10px 12px;
        }
    }

     @media (max-width: 800px){ 
        .footer-sj{
            margin-top: 50px;
        }
    }

    @media (max-width: 360px){ 
        .footer-sj ul li p a{
            font-size: 14px;
        }
        
        .footer-sj .contact .right p{
            font-size: 12px;
        }
    }

</style>








// WEBPACK FOOTER //
// src/components/Footer.vue